module.exports = __webpack_public_path__ + "static/media/CC.719db949.png";